import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useBpAdminFeeChargeCodeEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.BpAdminFeeChargeCode,
    false
  );

  return Boolean(isEnabled);
}
